import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { SocketService } from './shared/socket.service';
import { NotificationsService } from './layout/common/notifications/notifications.service';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, MatSnackBarModule]
})
export class AppComponent implements OnInit {
    /**
     * Constructor
     */
    constructor(
        private _socketService: SocketService,
        private _snackBar: MatSnackBar,
        private _notificationsService: NotificationsService,
        private _router: Router
    ) {
    }

    ngOnInit(): void {
        // Request permission for system notifications
        if (Notification.permission === 'default') {
            Notification.requestPermission();
        }

        const allowDevSockets = localStorage.getItem('ENABLE_DEV_SOCKETS') === 'true';
        const isLocalDevSocket = !environment.production && environment.wssBase.includes('localhost');
        if (isLocalDevSocket && !allowDevSockets) {
            return;
        }

        this._socketService.onMessage('notification').subscribe((data: any) => {
            if (data) {
                this.showNotification(data);
                // Refresh Notification List
                this._notificationsService.getAll().subscribe();
            }
        });
    }

    private showNotification(data: any): void {
        const message = data.message || 'Nueva Notificación';
        const type = data.type || 'info';

        // Play Sound
        this.playSound(type);

        // Show OS Notification
        if (Notification.permission === 'granted') {
            const notification = new Notification('Sistema Óptica', {
                body: message,
                icon: 'assets/icons/icon-128x128.png',
                data: data
            });
            notification.onclick = () => {
                window.focus();
                if (data.link && data.useRouter) {
                    this._router.navigate([data.link]);
                } else if (data.link) {
                    window.open(data.link, '_blank');
                }
                notification.close();
            };
        }

        // Show Toast
        this._snackBar.open(message, 'Cerrar', {
            duration: 5000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['notification-' + type] // You might want to add css for this
        });
    }

    private playSound(type: string): void {
        let audioSrc = 'assets/success.mp3'; // Default
        if (type === 'warning' || type === 'error') {
            audioSrc = 'assets/fail.mp3';
        }

        const audio = new Audio(audioSrc);
        audio.play().catch(err => console.error('Error playing sound:', err));
    }
}
